
import React from "react";
import { Calendar, Image, Check, Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const Features2 = () => {
  const features = [
    {
      icon: <Image className="h-10 w-10 text-toctoc-blue" />,
      title: "IA especializada em imóveis",
      description: "Algoritmo treinado especificamente para realçar espaços internos e externos de imóveis."
    },
    {
      icon: <Star className="h-10 w-10 text-toctoc-blue" />,
      title: "Resultados impecáveis",
      description: "Ajuste automático de iluminação, contraste, cores e perspectiva para fotos profissionais."
    },
    {
      icon: <Check className="h-10 w-10 text-toctoc-blue" />,
      title: "Simplicidade total",
      description: "Processo intuitivo direto no seu celular, sem necessidade de conhecimentos técnicos."
    },
    {
      icon: <Calendar className="h-10 w-10 text-toctoc-blue" />,
      title: "Rapidez incomparável",
      description: "Receba suas fotos editadas em minutos, não em dias. Seu tempo é valioso."
    }
  ];

  return (
    <section id="beneficios" className="py-16 md:py-24 bg-white">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-toctoc-gray-dark mb-4">
            Apresentação impecável sem complicação
          </h2>
          <p className="text-xl text-toctoc-gray-medium max-w-3xl mx-auto">
            O Toc Flash foi desenvolvido para corretores que valorizam excelência visual com máxima praticidade.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center p-4">
                  <div className="mb-5 p-3 rounded-full bg-toctoc-blue/10">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-toctoc-gray-dark mb-2">{feature.title}</h3>
                  <p className="text-toctoc-gray-medium">{feature.description}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-toctoc-beige to-toctoc-beige/60 p-8 rounded-xl">
          <p className="text-lg md:text-xl text-center text-toctoc-gray-dark">
            Basta fotografar com seu celular, enviar pelo aplicativo Toc Toc IA, e receber imagens de qualidade profissional em minutos — 
            sem intermediários, sem curva de aprendizado.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features2;
